import React from 'react'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import Editor from './editor'
import EditorService from 'live/services/editor'
import widgetsService from 'live/services/widgets'
import ChannelsValue from './channels-value'
import DashboardActions from './dashboard-actions'
import { observable, toJS, extendObservable, has, set } from 'mobx'
import { observer } from 'mobx-react'
import serviceLocator from 'live/services/service-locator'
import { DEFAULT_CHANNELS_CHART_CONFIG, addWidgetEditorToMenu } from 'plugin-assets/shared/widget/lib/util'

const widgetType = 'channels-value'

// check the flow type in definitions.js
const DEFAULT_CHART_CONFIG = {
    ...DEFAULT_CHANNELS_CHART_CONFIG,
    align: 'center',
    backgroundColor: '#00000000',
    valueBold: false,
    unitBold: false,
    valueItalic: false,
    unitItalic: false,
    valueFontColor: undefined,
    unitFontColor: undefined,
    valueFontColorOption: 'dashboard', // 'dashboard',  'default', 'custom'
    disableFormat: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    unitFontColorOption: 'dashboard', // 'dashboard',  'default', 'custom'
    backgroundColorOption: 'dashboard', // 'dashboard',  'default', 'custom'
    unitProportion: 100,
    maxHeight: 100,
    resizing: 'fitToHeightAndWidth',
    span: 'now',
    canChangeAssetOnVisualization: false,
    kind: widgetType
}

const ChannelsValueWidget = function(options = {}) {
    return {
        options: options,

        meta: observable.object({}),

        onStartQuery(event, layer, baseline) {
            if (!has(this.meta, '__color')) this.meta = extendObservable(this.meta, event.info)
            else set(this.meta, event.info)
        },

        flow(type, events, layer, baseline, preventRedraw = false) {
            switch (type) {
                case 'start':
                    this.onStartQuery(events, layer, baseline)
                    break
                case 'meta':
                    this.onStartQuery(events, layer, baseline)
                    break
                default:
                    break
            }
        },

        render() {
            if (_.isFunction(this.options.onReady)) this.options.onReady.apply(this)
            const self = this

            return observer(function ObserverChannelsValue(props) {
                return <ChannelsValue meta={toJS(self.meta)} {...props} />
            })
        },

        /* the properties below are necessary for backwards compatibility with the legacy code */
        setEl() {},
        destroy() {}
    }
}

const EditorInfo = {
    order: -8,
    type: 'channels-value-editor',
    label: i18n('Value channels chart'),
    description: i18n('Select the data channels using user interface instead of writing pipes code'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: Editor,
    defaultWidgetType: widgetType
})

widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })
widgetsService.policies(widgetType, {
    currentCrosshairValueCapacity: false
})
widgetsService.dashboardActions(widgetType, 'view', DashboardActions)
widgetsService.impl(widgetType, ChannelsValueWidget)
widgetsService.config(widgetType, DEFAULT_CHART_CONFIG)
widgetsService.queryHandlerKind(widgetType, widgetType)

addWidgetEditorToMenu({
    ...EditorInfo,
    thumbnail: require('../../assets/widget-channels-value-thumb.png').default,
    tags: ['assets', 'channels', 'value']
})

let displayUnitStore = null
serviceLocator.getService('plugin-assets:display-units').then(service => {
    displayUnitStore = service?.store
})

// making sure this wont throw in case live is outdated
widgetsService.getUserConfigForDownload &&
    widgetsService.getUserConfigForDownload(widgetType, cfg => {
        let displayUnitSetId = null
        if (typeof displayUnitStore?.getState === 'function') {
            displayUnitSetId = displayUnitStore.getState()?.selectedUnitSet?.id
        }

        return { assets: cfg.assets, download: true, displayUnitSetId }
    })
